/**
 * 	PRODUCT PAGE
 * 	  MEDIA ZOOM
 */

/* eslint-disable no-underscore-dangle */

let ppFWS = null;

let ppName = 'product-picture';

const noNavClass = `${ppName  }--no-nav`;

const sliderName = `${ppName  }__slider`;
const slidesName = `${ppName  }__slides`;

const customNavName = `${ppName  }__custom-nav`;
const thumbnailsName = `${ppName  }__thumbnails`;

const slideName = `${ppName  }__slide`;
const thumbnailName = `${ppName  }__thumbnail`;

const counterSlideName = `${ppName  }__counter-slide`;
const counterTotalName = `${ppName  }__counter-total`;

const arrowName = `${ppName  }__arrow`;
const topArrowName = `${arrowName  }--top`;
const bottomArrowName = `${arrowName  }--bottom`;
const arrowDsblClass = `${arrowName  }--disabled`;
const arrowHidingClass = `${arrowName  }--hidden`;

const pictureLazyLoadClass = 'js-picture-lazy';

let _pp = null;
let _slider = null;
let _slides = null;
let _customNav = null;
let _thumbnails = null;
let _counterSlide = null;
let _counterTotal = null;
let _arrows = null;
let _topArrow = null;
let _bottomArrow = null;


export function init() {
  ppName = 'product-picture';

  _pp = cube.$(`.${  ppName}`);

  _slider = cube.$(`#${  sliderName}`);
  _slides = _slider.$(`.${  slidesName}`);

  _customNav = cube.$(`.${  customNavName}`);
  _thumbnails = _customNav.$(`.${  thumbnailsName}`);

  _counterSlide = cube.$(`.${  counterSlideName}`);
  _counterTotal = cube.$(`.${  counterTotalName}`);

  _arrows = cube.$$(`.${  arrowName}`);
  _topArrow = cube.$(`.${  topArrowName}`);
  _bottomArrow = cube.$(`.${  bottomArrowName}`);


  handleArrows();
  handleModelChange();
};

function updateNavDisplay(){
  const holderHeight = _customNav.offsetHeight;
  let thumbnailsHeight;
  let navIsNeed;
  const updateArrowsDisplay = () => {
    thumbnailsHeight = _thumbnails.offsetHeight;
    navIsNeed = (thumbnailsHeight > holderHeight);

    _arrows.forEach((arrow) => {
      if(navIsNeed){
        arrow.classList.remove(arrowHidingClass);
      }else{
        arrow.classList.add(arrowHidingClass);
      }
    });

  };

  _customNav.$$('picture').forEach(() => {
    updateArrowsDisplay();
  });

  updateArrowsState();
};

function handleImgIndexIndicator(){
  _counterSlide.innerHTML = 1;
  _counterTotal.innerHTML = ppFWS.initialLength;
  ppFWS.on('slideChanged', (slideIndex) => {
    _counterSlide.innerHTML = slideIndex - 1;
  });
};

function handleModelChange() {
  const defaultId = cube.$$('.product-picture__slides--alt')[0].dataset.modelId;

  function updateDom(newModelId) {
    const addableSlidesHolder = cube.$(`.${  slidesName  }--alt[data-model-id="${  newModelId  }"]`);
    const  addableThumbnailsHolder = cube.$(`.${  thumbnailsName  }--alt[data-model-id="${  newModelId  }"]`);
    const  addableSlides = addableSlidesHolder.$$(`.${  slideName}`);
    const  addableThumbnails = addableThumbnailsHolder.$$(`.${  thumbnailName}`);

    const  newSlidesFragment = document.createDocumentFragment();
    const  newThumbnailsFragment = document.createDocumentFragment();

    function flushContainers() {
      // Clean all elements from the full-width slider container
      cube.$('.product-picture__slides').innerHTML = '';
      _thumbnails.innerHTML = '';
    }

    function buildContainer() {
      // delete potential existing full-width slider...
      if (ppFWS) ppFWS.destroy();
      // ...and build a new one
      ppFWS = cube.fullWidthSlider('productPicture', _slider);
      handleImgIndexIndicator();

    }

    flushContainers();

    // build a fragment with new slides
    addableSlides.forEach((slide) => {

      const slideClone = slide.cloneNode(true);
      const slideImg = slideClone.$('img');
      const slidePict = slideClone.$('picture');

      // get id from dataset then remove the data-id
      slideClone.id = slideClone.dataset.id;
      slideClone.removeAttribute('data-id');

      if(slideImg){slideImg.classList.add(pictureLazyLoadClass);};
      if(slidePict){slidePict.classList.add(pictureLazyLoadClass);};

      newSlidesFragment.appendChild(slideClone);
    });

    // build a fragment with new thumbnails
    addableThumbnails.forEach((thumbnail) => {
      const thumbnailClone = thumbnail.cloneNode(true);
      newThumbnailsFragment.appendChild(thumbnailClone);
    });

    // add fragments to dom, then build a new full-width slider
    _slides.appendChild(newSlidesFragment);

    if (addableThumbnails.length > 1) {
      _thumbnails.appendChild(newThumbnailsFragment);
      _pp.classList.remove(noNavClass);
    } else {
      _pp.classList.add(noNavClass);
    }

    buildContainer();

    updateNavDisplay();

  }

  cube.event.on('modelChanged', (newModelId) => {
    updateDom(newModelId);
    cube.lazyload.updateObserver(); //for the case of 1 picture only for the chosen product model. Should be optimizable
  });

  updateDom(defaultId);
  cube.lazyload.updateObserver(); //for the case of 1 picture only for the default product model. Should be optimizable
};


function updateArrowsState () {

  const HighLimit = _customNav.scrollHeight - _customNav.offsetHeight - 1;

  if( _customNav.scrollTop <= 0){
    _topArrow.classList.add(arrowDsblClass);
  }else{
    _topArrow.classList.remove(arrowDsblClass);
  }

  if(_customNav.scrollTop >= HighLimit){
    _bottomArrow.classList.add(arrowDsblClass);
  }else{
    _bottomArrow.classList.remove(arrowDsblClass);
  }

};

function handleArrows() {
  const step = 0.5;

  _arrows.forEach((btn) => {
    btn.addEventListener('click', () => {
      const direction = (btn.dataset.direction === 'up') ? '-' : '+';
      const height = _customNav.offsetHeight * step;
      $(`.${  customNavName}`).scrollTo( `${direction  }=${  height}` , 150 );
    });
  });

  _customNav.addEventListener('scroll', cube.debounce(updateArrowsState, 75));

};



// WEBPACK FOOTER //
// ./src/catalog/product-details/product-picture.js